import { render, staticRenderFns } from "./CompactCard.vue?vue&type=template&id=af398caa&scoped=true&"
import script from "./CompactCard.vue?vue&type=script&lang=js&"
export * from "./CompactCard.vue?vue&type=script&lang=js&"
import style0 from "./CompactCard.vue?vue&type=style&index=0&id=af398caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af398caa",
  null
  
)

export default component.exports